<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->

<!-- Content -->
<div id="wrapper">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <ng-container *ngIf="!isPassport">{{'kyc.camera_title' | translate}}</ng-container>
        <ng-container *ngIf="isPassport">{{'kyc.camera_passport_title' | translate}}</ng-container>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-2">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true">
          <div class="row d-flex justify-content-between">
            <div class="col-md-12 col-lg-8 pt-5 pb-5">
              <div class="info-wrap">
                <div class="face">
                  <div class="icon" (click)="handleCamera(typeCamera.face)" matTooltip="{{'kyc.tooltip_face' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.face)">
                    <img *ngIf="faceImage" [src]="faceImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_face' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkFaceImage" style="color: #FF0000">{{'kyc.image_face_required' | translate}}</span>
                  </div>
                </div>
                <div class="cccd mt-5">
                <div class="cccd_before" *ngIf="!isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.before)" matTooltip="{{'kyc.tooltip_before' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.before)">
                    <img *ngIf="cccdBeforeImage" [src]="cccdBeforeImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_before' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkCccdBeforeImage" style="color: #FF0000">{{'kyc.image_before_required' | translate}}</span>
                  </div>
                </div>
                <div class="cccd_after" *ngIf="!isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.after)" matTooltip="{{'kyc.tooltip_after' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.after)">
                    <img *ngIf="cccdAfterImage" [src]="cccdAfterImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_after' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkCccdAfterImage" style="color: #FF0000">{{'kyc.image_after_required' | translate}}</span>
                  </div>
                </div>
                <div class="passport cccd_after" *ngIf="isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.passport)" matTooltip="{{'kyc.tooltip_passport' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.passport)">
                    <img *ngIf="passportImage" [src]="passportImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_passport' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkPassportImage" style="color: #FF0000">{{'kyc.image_passport_required' | translate}}</span>
                  </div>
                </div>
              </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-4 pt-5 pb-5 pr-2">
              <div class="camera-wrap">
                <div class="title-camera">
                  <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.face">{{'kyc.capture_face' | translate}}</ng-container>
                  <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.before">{{'kyc.capture_before' | translate}}</ng-container>
                  <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.after">{{'kyc.capture_after' | translate}}</ng-container>
                  <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.passport">{{'kyc.image_passport' | translate}}</ng-container>
                </div>
                <div class="webcam text-center">
                  <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                          [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                          (initError)="handleInitError($event)"></webcam>
                </div>

                <div class="group-btn mt-3">
                  <button mat-stroked-button color="primary" class="mr-3" (click)="triggerSnapshot()" [disabled]="checkCapture">
                    <img width="22" src="assets/images/icon-camera.png" alt="camera">
                    {{'kyc.capture' | translate}}
                  </button>
                  <button mat-stroked-button color="primary" class="mr-3" (click)="captureAgain()" [disabled]="checkCaptureAgain">
                    <mat-icon class="mr-0">replay</mat-icon>
                    {{'kyc.capture_again' | translate}}
                  </button>
                </div>
                <!--              <div class="actionBtn" (click)="showNextWebcam(true);" title="Switch Camera">🔁</div>-->
              </div>
            </div>
          </div>

          <div style="color: red" class="pb-5" *ngIf="errors.length > 0">{{ 'kyc.no_camera' | translate }}</div>
<!--          <ul *ngFor="let error of errors">-->
<!--            <li>{{error | json}}</li>-->
<!--          </ul>-->

        </mat-expansion-panel>
        <div class="scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100" id="navigation" #navigation>
          <button id="btn-cancel" mat-stroked-button color="primary" class="mr-2" type="button" (click)="cancelKyc()">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
          </button>
          <button mat-raised-button color="primary" class="ml-2" (click)="confirmKyc()">
            <mat-icon class="mr-0">gesture</mat-icon>
            {{'kyc.confirm' | translate}}
          </button>
        </div>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</div>

<!-- The Modal -->
<div id="myModal" class="modal" *ngIf="modalImage">
  <span class="close" (click)="closeZoomImage()">&times;</span>
  <img [src]="modalImage.imageAsDataUrl" />
</div>
